import React from 'react';
import { css, keyframes } from '@emotion/css';
import { corporateGreyLight, corporateBlue } from '../assets/colors';

/**
 * @brief Renders a simple spinning loading icon.
 */
const Loader = () => {
    const spin = keyframes`
    0% { 
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }`;
    return (
        <div
            className={css({
                width: '100vw',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            })}
        >
            <div
                className={css({
                    border: `4px solid ${corporateGreyLight}` /* Light grey */,
                    borderTop: `4px solid ${corporateBlue}` /* Blue */,
                    borderRadius: '50%',
                    width: '80px',
                    height: '80px',
                    animation: `${spin} 2s linear infinite`,
                })}
            />
        </div>
    );
};

export default Loader;
